module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-32.6567af77.png";